module.exports = __webpack_public_path__ + "img/register.63952689.svg";